import every from 'lodash/every';
import isNumber from 'lodash/isNumber';
import { createSelector } from '@reduxjs/toolkit';
import { getState } from '@yme/selectors/common';
const getGoogleLocationSearchState = createSelector(getState, (state) => state.googleLocationSearch);
export const getDealerLocatorSearchedPlace = createSelector(getGoogleLocationSearchState, (state) => state.searchedPlace);
export const getIsSearchedPlaceEmpty = createSelector(getDealerLocatorSearchedPlace, (searchedPlace) => every(searchedPlace, (item) => !item));
export const getReadableSearchedPlace = createSelector(getDealerLocatorSearchedPlace, ({ latitude, longitude, value }) => {
    if (isNumber(latitude) && isNumber(longitude)) {
        return `${latitude}, ${longitude}`;
    }
    return value ?? '';
});
export const getMyLocation = createSelector(getDealerLocatorSearchedPlace, ({ latitude, longitude }) => {
    if (!latitude || !longitude) {
        return undefined;
    }
    return {
        lat: latitude,
        lng: longitude,
    };
});
